import { IDirectorate } from "./Directorate";
import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IOrgLevel1 } from "./OrgLevel1";
import { IOrgLevel3 } from "./OrgLevel3";
import { IPortfolio } from "./Portfolio";
import { IPPVisionObjective } from "./PPVisionObjective";

export interface IPPObjective extends IEntityWithStatus {
    Description?: string
    CustomerID: number | null;
    OwnerTypeID?: number;
    OwnerL0ID?: number;
    OwnerL1ID?: number;
    OwnerL2ID?: number;
    OwnerL3ID?: number;
    OwnerL1?: IOrgLevel1;
    OwnerL2?: IDirectorate;
    OwnerL3?: IOrgLevel3;
    PPObjectiveVisions?: IPPVisionObjective[];
    Portfolios?: IPortfolio[];
}

export class PPObjective extends EntityWithStatus implements IPPObjective {
    public Description = null;
    public CustomerID = null;
    public OwnerTypeID = null;
    public OwnerL0ID = null;
    public OwnerL1ID = null;
    public OwnerL2ID = null;
    public OwnerL3ID = null;
}